export type TicketUpdateBadge = {
  count: number
  cursor: string
}

export const normalizeTicketUpdateBadge = (data: unknown): TicketUpdateBadge => {
  const payload = data && typeof data === 'object' ? (data as Record<string, unknown>) : {}

  return {
    count: Number.isInteger(payload.count) && Number(payload.count) >= 0 ? Number(payload.count) : 0,
    cursor: typeof payload.cursor === 'string' ? payload.cursor : ''
  }
}

export const formatTicketUpdateCount = (count: number): string => (count > 99 ? '99+' : String(Math.max(0, count)))

export const shouldAcknowledgeTicketUpdates = (activeTab: string, count: number, cursor: string): boolean =>
  activeTab === 'tickets' && count > 0 && cursor.length > 0
